const desktopMenu = {
  parents: [],

  addActive: function () {
    this.searchTrigger.classList.remove("active");
    this.root.classList.add("menu-active");
  },

  removeActive: function () {
    this.root.classList.remove("menu-active");
  },

  toggleSearch: function (e) {
    if (this.mainSearch.contains(e.target)) {
      return;
    }

    this.searchTrigger.classList.toggle("active");
    this.root.classList.add("menu-active");

    if (this.searchTrigger.classList.contains("active")) {
      this.root.classList.add("menu-active");

      const searchField = document.querySelector(
        ".main-search-field .aa-Input"
      );

      if (searchField) {
        searchField.focus();
      }
    } else {
      this.root.classList.remove("menu-active");
    }
  },

  disableSearch: function () {
    if (!this.searchTrigger.classList.contains("active")) {
      return;
    }

    this.searchTrigger.classList.remove("active");
    this.root.classList.remove("menu-active");
  },

  handleClickOutsideSearch: function (e) {
    if (
      !this.searchTrigger.contains(e.target) &&
      !this.mainSearch.contains(e.target) &&
      this.root.classList.contains("menu-active")
    ) {
      this.disableSearch();
    }
  },

  init: function () {
    this.root = document.getElementsByTagName("html")[0];
    this.submenus = document.querySelectorAll(".main-header .nav-submenu");
    this.searchTrigger = document.querySelector(".main-search-trigger");
    this.mainSearch = document.querySelector(".main-search");

    this.submenus.forEach((submenu) => {
      this.parents.push(submenu.parentNode);
    });

    this.parents.forEach((parent) => {
      parent.addEventListener("mouseover", this.addActive.bind(this));
      parent.addEventListener("mouseout", this.removeActive.bind(this));
    });

    this.searchTrigger.addEventListener("click", this.toggleSearch.bind(this));

    document.addEventListener(
      "click",
      this.handleClickOutsideSearch.bind(this)
    );
  },

  kill: function () {
    if (this.parents.length) {
      this.parents.forEach((parent) => {
        parent.removeEventListener("mouseover", this.addActive);
        parent.removeEventListener("mouseout", this.removeActive);
      });

      this.parents = [];
    }
  },
};

export default desktopMenu;
